import React, { FC } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import { cn } from 'components/lib/utils';
import { Popover, PopoverContent, PopoverTrigger } from 'components/ui/popover';

interface IDayCardProps {
  dayLabel: string;
  rewardCount: number;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onClose?: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export const DayCard: FC<IDayCardProps> = ({
  dayLabel,
  rewardCount,
  isOpen,
  onOpenChange,
  onClose,
  children,
  footer
}) => (
  <Popover open={isOpen} onOpenChange={onOpenChange}>
    <PopoverTrigger asChild>
      <button
        type="button"
        className={cn(
          'group flex h-8 w-32 min-w-32 shrink-0 items-center justify-between rounded-md border border-base-input bg-base-background py-2 px-3 text-p-s transition-colors',
          'hover:border-indigo-600 hover:bg-purple-50',
          'data-[state=open]:border-indigo-600 data-[state=open]:bg-purple-50'
        )}
      >
        <span className="text-p-xs font-medium leading-none text-base-foreground group-hover:text-indigo-600 group-data-[state=open]:text-base-foreground">
          {dayLabel}
        </span>
        <span
          className={cn(
            'inline-flex items-center gap-1',
            rewardCount > 0 ? 'text-indigo-500' : 'text-base-mutedForeground'
          )}
        >
          <FontAwesomeIcon
            icon="fa-regular fa-gift"
            className="text-sm leading-none"
          />
          <span>{rewardCount}</span>
        </span>
      </button>
    </PopoverTrigger>
    <PopoverContent
      align="start"
      side="bottom"
      sideOffset={8}
      className={cn(
        'relative w-80 rounded-md border border-base-border bg-base-background p-6 shadow-xl',
        'flex min-h-0 max-h-[min(448px,calc(100dvh-5rem))] flex-col overflow-hidden'
      )}
    >
      {onClose != null ? (
        <button
          type="button"
          aria-label="Close day rewards"
          className="absolute right-4 top-4 z-20 inline-flex size-6 items-center justify-center rounded text-black hover:opacity-80"
          onClick={onClose}
        >
          <FontAwesomeIcon
            icon="fa-regular fa-xmark"
            className="text-p-s font-semibold leading-none text-black"
          />
        </button>
      ) : null}
      <div className="flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden">
        {children}
        {footer != null ? <div className="mt-2 shrink-0">{footer}</div> : null}
      </div>
    </PopoverContent>
  </Popover>
);
